import React, { FC } from 'react';
import {
  Modal,
  ModalOverlay,
  ModalContent,
  ModalHeader,
  ModalFooter,
  ModalBody,
  ModalCloseButton,
  Button,
  Text,
} from '@wegroup/design-system';
import { useTranslation } from 'react-i18next';
import { AnvaPossiblePackage } from '@flows/src/types/anva';
import AnvaAddToPackageModalContent from '@flows/src/components/flow-products/quotes/basket/AnvaAddToPackageModalContent';
import { chakraCustomScrollBar } from '../../../../../../common/src/utils/styledComponentsUtils';

interface Props {
  isOpen: boolean;
  onClose: () => void;
  packageOptions: AnvaPossiblePackage[];
  onAddToPackage: (packageCode: string) => void;
}

const AnvaAddToPackageModal: FC<Props> = ({
  isOpen,
  onClose,
  packageOptions,
  onAddToPackage,
}) => {
  const { t } = useTranslation();
  const [selectedPackageCode, setSelectedPackageCode] = React.useState<
    string | null
  >(null);

  const handleClose = () => {
    onClose();
  };
  const handleAdd = () => {
    if (selectedPackageCode) {
      onAddToPackage(selectedPackageCode);
      onClose();
    }
  };

  return (
    <Modal isOpen={isOpen} onClose={handleClose} size="xl">
      <ModalOverlay />
      <ModalContent maxH="80vh" display="flex" flexDirection="column">
        <ModalHeader>
          {t('FLOW_PRODUCTS_BASKET_CHOOSE-A-PACKAGE_TITLE')}
        </ModalHeader>
        <ModalCloseButton />
        <ModalBody overflowY="auto" p="6" sx={chakraCustomScrollBar}>
          <Text color="gray.500" mb="4">
            {t('FLOW_PRODUCTS_BASKET_CHOOSE-A-PACKAGE_DESCRIPTION')}
          </Text>
          <AnvaAddToPackageModalContent
            selectedPackageCode={selectedPackageCode}
            onPackageSelect={setSelectedPackageCode}
            packageOptions={packageOptions}
          />
        </ModalBody>

        <ModalFooter>
          <Button variant="grayedGhost" mr={3} onClick={onClose}>
            {t('CLOSE')}
          </Button>
          <Button onClick={handleAdd} isDisabled={!selectedPackageCode}>
            {t('Confirm')}
          </Button>
        </ModalFooter>
      </ModalContent>
    </Modal>
  );
};

export default AnvaAddToPackageModal;
